import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'

import { bonusEngineSelector } from '@/state/bonus-engine/slices/index.slices'
import { useBonusActions } from './use-bonuses-actions.hook'

export const useBonusFilters = () => {
  const { getAllBonuses, setBonusFilters } = useBonusActions()

  const { filters, pagination } = useSelector(bonusEngineSelector)

  // eslint-disable-next-line
  const filterDelay = useCallback(
    debounce((newFilters: any) => {
      getAllBonuses(newFilters)
    }, 500),
    [],
  )

  const handleChangeSearch = (
    field: string,
    value: string,
    debounce?: boolean,
  ) => {
    const newFilters = {
      ...filters,
      [field]: value,
      page: 1,
    }

    setBonusFilters(newFilters)

    if (debounce) {
      filterDelay(newFilters)
    } else {
      getAllBonuses(newFilters)
    }
  }

  const handleChangePage = (newPage: number) => {
    setBonusFilters({ ...filters, page: newPage })
    getAllBonuses({ ...filters, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (Math.ceil(pagination.total / newLimit) < (filters.page || 1)) {
      setBonusFilters({ ...filters, limit: newLimit, page: 1 })
      getAllBonuses({ ...filters, limit: newLimit, page: 1 })
    } else {
      setBonusFilters({ ...filters, limit: newLimit })
      getAllBonuses({ ...filters, limit: newLimit })
    }
  }

  return {
    filters,
    handleChangeSearch,
    handleChangePage,
    handleChangeLimit,
  }
}
